import React, { useState } from 'react';
import { Fish } from 'lucide-react';

interface YakaBassLogoProps {
  className?: string;
  showText?: boolean;
}

const YakaBassLogo: React.FC<YakaBassLogoProps> = ({ 
  className = "w-12 h-12",
  showText = true 
}) => {
  const [imageError, setImageError] = useState(false);
  
  // Fallback SVG logo component that matches the original design
  const FallbackLogo = () => (
    <div className={`${className} relative`}>
      <svg 
        viewBox="0 0 100 100" 
        className="w-full h-full"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Outer circle */}
        <circle 
          cx="50" 
          cy="50" 
          r="48" 
          stroke="#2563eb" 
          strokeWidth="4" 
          fill="white"
          className="drop-shadow-lg"
        />
        
        {/* Inner circle for fish */}
        <circle 
          cx="50" 
          cy="50" 
          r="32" 
          stroke="#2563eb" 
          strokeWidth="2" 
          fill="none"
        />
        
        {/* Bass fish silhouette */}
        <path
          d="M30 50 Q40 42 50 50 Q60 58 70 50 Q65 45 60 47 Q55 49 50 50 Q45 51 40 53 Q35 55 30 50Z"
          fill="#2563eb"
          stroke="#1d4ed8"
          strokeWidth="1"
        />
        
        {/* Kayaker silhouette on top */}
        <path
          d="M48 25 Q50 22 52 25 L52 30 L48 30 Z"
          fill="#1d4ed8"
        />
        
        {/* Top text */}
        <text 
          x="50" 
          y="18" 
          textAnchor="middle" 
          className="text-xs font-bold fill-current text-blue-600"
          fontSize="8"
        >
          YAK-A-BASS
        </text>
        
        {/* Bottom text */}
        <text 
          x="50" 
          y="88" 
          textAnchor="middle" 
          className="text-xs font-bold fill-current text-blue-600"
          fontSize="8"
        >
          NOR-CAL
        </text>
      </svg>
    </div>
  );
  
  return (
    <div className="flex items-center space-x-3">
      {/* Logo Image */}
      <div className={`${className} relative`}>
        {!imageError ? (
          <img 
            src="/yakabass-logo.webp" 
            alt="YAK-A-BASS NOR-CAL Logo" 
            className="w-full h-full object-contain drop-shadow-lg"
            onError={() => setImageError(true)}
          />
        ) : (
          <FallbackLogo />
        )}
      </div>
      
      {/* Optional Text */}
      {showText && (
        <div className="flex flex-col">
          <h1 className="font-bold text-xl text-slate-800 leading-tight">YAK-A-BASS</h1>
          <p className="text-sm text-slate-600 font-medium leading-tight">NOR-CAL</p>
        </div>
      )}
    </div>
  );
};

export default YakaBassLogo;